// extracted by mini-css-extract-plugin
module.exports = {"skillContainer":"Container_skillContainer__mukB3","heading":"Container_heading__366NX","years":"Container_years__1o2Me"};